import { render, staticRenderFns } from "./CallDeploy.vue?vue&type=template&id=28fa8dd3&scoped=true&"
import script from "./CallDeploy.vue?vue&type=script&lang=js&"
export * from "./CallDeploy.vue?vue&type=script&lang=js&"
import style0 from "./CallDeploy.vue?vue&type=style&index=0&id=28fa8dd3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fa8dd3",
  null
  
)

export default component.exports